import { useRef } from 'react';
import { Monitor, Smartphone, Palette, PenTool, Layers, Layout } from 'lucide-react';

const services = [
  {
    icon: Monitor,
    title: 'Website Development',
    description: 'Custom, responsive websites built with modern technologies for optimal performance and user experience.',
  },
  {
    icon: Smartphone,
    title: 'App Development',
    description: 'Native and cross-platform mobile applications that engage users and drive business growth.',
  },
  {
    icon: Layout,
    title: 'UI/UX Design',
    description: 'User-centered interface designs that deliver intuitive experiences and drive engagement.',
  },
  {
    icon: Palette,
    title: 'Graphic Design',
    description: 'Striking visual designs that communicate your brand message effectively across all mediums.',
  },
  {
    icon: PenTool,
    title: 'Logo & Name Card Design',
    description: 'Memorable logos and professional business cards that capture your brand essence and make lasting impressions.',
  },
  {
    icon: Layers,
    title: 'Brand Identity',
    description: 'Comprehensive branding solutions that establish a cohesive visual language for your business.',
  },
];

const Services = () => {
  const sectionRef = useRef<HTMLElement>(null);

  return (
    <section id="services" ref={sectionRef} className="section-padding bg-background">
      <div className="container-padding max-w-7xl mx-auto">
        <div className="text-center mb-16 md:mb-20">
          <p className="text-eyebrow font-medium text-sm mb-4">Our Services</p>
          <h2 className="heading-lg text-foreground mb-6">
            What we do best
          </h2>
          <p className="text-body max-w-2xl mx-auto">
            We craft digital experiences across every medium — helping your brand stand out and your business thrive in the modern world.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10">
          {services.map((service, index) => (
            <div
              key={service.title}
              className="group p-8 md:p-10 rounded-2xl bg-card border border-border hover:border-primary/30 transition-all duration-300 hover-lift"
            >
              <div className="w-14 h-14 rounded-xl bg-primary/10 flex items-center justify-center mb-6 group-hover:bg-primary/20 transition-colors duration-300">
                <service.icon className="w-7 h-7 text-primary" aria-hidden="true" focusable="false" />
              </div>
              <h3 className="heading-md text-foreground mb-4">{service.title}</h3>
              <p className="text-body">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
